<template>
<img src="../../assets/marca.png" alt="Baba FIPLAN" :style="{height}"/>
</template>

<script>
export default {
  name: "AppLogo",
  props: ['height']
}
</script>

<style scoped>

</style>